<template>
    <BaseTable
        data-cy="deportistas-equipos-table"
        :columns="columns"
        :data="deportistas"
        :loading="loading"
        :skeleton="skeleton"
        :skeleton-rows="skeletonRows"
        empty-text="No hay deportistas en este equipo"
        :default-col-width="defaultColWidth"
    >
        <!-- Skeleton headers -->
        <template #skeleton-header-activo>
            <div class="tw:h-3 tw:bg-gray-200 tw:rounded tw:w-4 tw:mx-auto"></div>
        </template>
        <template #skeleton-header-nombre>
            <div class="tw:h-3 tw:bg-gray-200 tw:rounded tw:w-14"></div>
        </template>
        <template #skeleton-header-apellidos>
            <div class="tw:h-3 tw:bg-gray-200 tw:rounded tw:w-20"></div>
        </template>
        <template #skeleton-header-importe_total>
            <div class="tw:h-3 tw:bg-gray-200 tw:rounded tw:w-20 tw:mx-auto"></div>
        </template>
        <template #skeleton-header-importe_pagado>
            <div class="tw:h-3 tw:bg-gray-200 tw:rounded tw:w-20 tw:mx-auto"></div>
        </template>
        <template #skeleton-header-importe_pendiente>
            <div class="tw:h-3 tw:bg-gray-200 tw:rounded tw:w-24 tw:mx-auto"></div>
        </template>
        <template #skeleton-header-acciones>
            <div class="tw:h-3 tw:bg-gray-200 tw:rounded tw:w-28 tw:mx-auto"></div>
        </template>

        <!-- Skeleton rows -->
        <template #skeleton-activo>
            <div class="tw:h-4 tw:w-4 tw:bg-gray-200 tw:rounded-full tw:mx-auto"></div>
        </template>
        <template #skeleton-nombre>
            <div class="tw:h-4 tw:bg-gray-200 tw:rounded tw:w-24"></div>
        </template>
        <template #skeleton-apellidos>
            <div class="tw:h-4 tw:bg-gray-200 tw:rounded tw:w-32"></div>
        </template>
        <template #skeleton-importe_total>
            <div class="tw:h-4 tw:bg-gray-200 tw:rounded tw:w-20 tw:mx-auto"></div>
        </template>
        <template #skeleton-importe_pagado>
            <div class="tw:h-4 tw:bg-gray-200 tw:rounded tw:w-20 tw:mx-auto"></div>
        </template>
        <template #skeleton-importe_pendiente>
            <div class="tw:h-4 tw:bg-gray-200 tw:rounded tw:w-24 tw:mx-auto"></div>
        </template>
        <template #skeleton-acciones>
            <div class="tw:h-9 tw:w-28 tw:bg-gray-200 tw:rounded tw:mx-auto"></div>
        </template>

        <template #cell-activo="{ row }">
            <div
                :class="['tw:h-3 tw:w-3 tw:rounded-full', getActivoClass(row.activo)]"
                :title="getActivoTitle(row.activo)"
            ></div>
        </template>

        <template #cell-importe_total="{ row }">
            <span>{{ row.importe_total | formatear_precio }}</span>
        </template>

        <template #cell-importe_pagado="{ row }">
            <span>{{ row.importe_pagado | formatear_precio }}</span>
        </template>

        <template #cell-importe_pendiente="{ row }">
            <span>{{ row.importe_pendiente | formatear_precio }}</span>
        </template>

        <template #cell-acciones="{ row }">
            <OptionsDropdownComponent
                :options="getRowOptions(row)"
            />
        </template>
    </BaseTable>
</template>

<script setup>
    import BaseTable from '@/modules/admin/ui/table/BaseTable.vue';
    import OptionsDropdownComponent from '@/modules/admin/ui/OptionsDropdownComponent.vue';

    const props = defineProps({
        deportistas: {
            type: Array,
            default: () => []
        },
        loading: {
            type: Boolean,
            default: false
        },
        skeleton: {
            type: Boolean,
            default: false
        },
        skeletonRows: {
            type: Number,
            default: 6
        },
        columns: {
            type: Array,
            required: true
        },
        listaId: {
            type: [String, Number],
            default: null
        },
        defaultColWidth: {
            type: String,
            default: '120px'
        }
    });

    function getRowOptions(row) {
        return [
            {
                to: {
                    name: 'back.bases.show',
                    params: { lista_id: props.listaId, base_id: row.id }
                },
                label: 'Ver deportista',
                icon: 'eye'
            }
        ];
    }

    function getActivoClass(value) {
        return value === 1 ? 'tw:bg-green-500' : 'tw:bg-red-500';
    }

    function getActivoTitle(value) {
        return value === 1 ? 'Activo' : 'Inactivo';
    }
</script>
